export default "__VITE_ASSET__CEXjyUEN__"